/* eslint-disable @typescript-eslint/no-unused-vars */
import type { PayloadAction } from '@reduxjs/toolkit';
import { createSelector, createSlice } from '@reduxjs/toolkit';
import { Scenario } from '@scenario/models/scenario.model';
import { RootState } from '../../create-store';
import { SearchScenariosFormModel } from '@app/scenarios/search-scenarios-form/search-scenarios-form.model';

export interface ScenariosState {
  scenarios: Scenario[];
  isFetching: boolean;
  error?: string;
}

const initialState: ScenariosState = {
  scenarios: [],
  isFetching: false,
};

export const scenariosSlice = createSlice({
  name: 'scenarios',
  initialState,
  reducers: {
    retrieveScenariosByFilters: (state, _action: PayloadAction<SearchScenariosFormModel>) => {
      state.isFetching = true;
      state.scenarios = [];
    },
    retrieveScenarios: state => {
      state.isFetching = true;
    },
    retrieveScenariosSuccess: (state, action: PayloadAction<Scenario[]>) => {
      state.scenarios = action.payload;
      state.isFetching = false;
    },
    retrieveScenariosFailure: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
      state.isFetching = false;
    },
    clearScenarios: state => {
      state.scenarios = [];
    },
  },
});

export type ScenariosViewModel = {
  scenarios: Scenario[];
  isFetching: boolean;
  error?: string;
};

export const selectScenariosViewModel = createSelector(
  (state: RootState) => state,
  (state): ScenariosViewModel => ({
    scenarios: state.scenarios.scenarios,
    isFetching: state.scenarios.isFetching,
    error: state.scenarios.error,
  }),
);
export const {
  retrieveScenarios,
  retrieveScenariosByFilters,
  retrieveScenariosSuccess,
  retrieveScenariosFailure,
  clearScenarios,
} = scenariosSlice.actions;

export default scenariosSlice.reducer;
